import { IState } from "Model/State/IState";
import { IItem } from "Model/Storage/IItem";

export function selectShowIgnoredValuesDialog(state: IState): boolean {
  return state.staging.showIgnoredValuesDialog ?? false;
}

export function selectIgnoredValues(state: IState): IItem {
  return state.staging.ignoredValues;
}

export function selectStagingValues(state: IState): IItem {
  return state.staging.values;
}
